import type { AmbientacaoGateway } from '@/application/port/out/AmbientacaoGateway';
import type { Ambientacao, UpsertAmbientacaoCommand } from '@/domain/model/Ambientacao';

export class ListAmbientacoes {
  constructor(private readonly gateway: AmbientacaoGateway) {}
  execute(): Promise<Ambientacao[]> { return this.gateway.list(); }
}
export class CreateAmbientacao {
  constructor(private readonly gateway: AmbientacaoGateway) {}
  execute(cmd: UpsertAmbientacaoCommand): Promise<Ambientacao> { return this.gateway.create(cmd); }
}
export class UpdateAmbientacao {
  constructor(private readonly gateway: AmbientacaoGateway) {}
  execute(id: string, cmd: UpsertAmbientacaoCommand): Promise<Ambientacao> { return this.gateway.update(id, cmd); }
}
export class ArquivarAmbientacao {
  constructor(private readonly gateway: AmbientacaoGateway) {}
  execute(id: string): Promise<void> { return this.gateway.arquivar(id); }
}
